module.exports = __webpack_public_path__ + "img/ae.61f9f9f9.svg";